var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlackAndWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "e8bbc2dd1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 236.164062 11.808594 L 449.003906 11.808594 L 449.003906 32.160156 L 236.164062 32.160156 Z M 236.164062 11.808594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 7305823555
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.347656 80.152344 L 166.882812 80.152344 L 166.882812 100.144531 L 2.347656 100.144531 Z M 2.347656 80.152344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e8bbc2dd1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 236.164062 11.808594 L 449.027344 11.808594 L 449.027344 32.160156 L 236.164062 32.160156 Z M 236.164062 11.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.815187, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.328125 0 L 6.5625 0 L 8.285156 -4.4375 L 18.480469 -4.4375 L 20.203125 0 L 26.4375 0 L 16.242188 -25.667969 L 10.523438 -25.667969 Z M 9.789062 -9.019531 L 13.382812 -18.40625 L 17.011719 -9.019531 Z M 9.789062 -9.019531 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.164208, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.078125 0 L 8.875 0 L 8.875 -15.472656 L 15.105469 -6.34375 L 19.140625 -6.34375 L 25.371094 -15.4375 L 25.371094 0 L 31.167969 0 L 31.167969 -25.667969 L 26.253906 -25.667969 L 17.160156 -12.355469 L 8.03125 -25.667969 L 3.078125 -25.667969 Z M 3.078125 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.990928, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.078125 0 L 8.910156 0 L 8.910156 -7.148438 L 13.125 -7.148438 C 19.324219 -7.148438 23.320312 -10.78125 23.320312 -16.390625 C 23.320312 -22.035156 19.324219 -25.667969 13.125 -25.667969 L 3.078125 -25.667969 Z M 8.875 -12.171875 L 8.875 -20.570312 L 12.648438 -20.570312 C 15.691406 -20.570312 17.378906 -19.03125 17.378906 -16.351562 C 17.378906 -13.675781 15.691406 -12.171875 12.648438 -12.171875 Z M 8.875 -12.171875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.957358, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.078125 0 L 20.128906 0 L 20.128906 -5.464844 L 8.910156 -5.464844 L 8.910156 -25.667969 L 3.078125 -25.667969 Z M 3.078125 0 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.661461, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.078125 0 L 8.910156 0 L 8.910156 -25.667969 L 3.078125 -25.667969 Z M 3.078125 0 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.238384, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.078125 0 L 8.910156 0 L 8.910156 -8.835938 L 18.222656 -8.835938 L 18.222656 -13.96875 L 8.910156 -13.96875 L 8.910156 -20.386719 L 19.175781 -20.386719 L 19.175781 -25.667969 L 3.078125 -25.667969 Z M 3.078125 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.612588, 34.421482)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.789062 0 L 15.621094 0 L 15.621094 -9.054688 L 25.042969 -25.667969 L 18.40625 -25.667969 L 15.253906 -19.726562 L 12.722656 -15.070312 L 10.15625 -19.726562 L 6.964844 -25.667969 L 0.328125 -25.667969 L 9.789062 -8.984375 Z M 9.789062 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.922305, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.105469 0 L 8.988281 0 L 8.988281 -25.894531 L 3.105469 -25.894531 Z M 3.105469 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.675305, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.105469 0 L 8.953125 0 L 8.953125 -15.871094 L 20.382812 0 L 25.375 0 L 25.375 -25.894531 L 19.53125 -25.894531 L 19.53125 -10.136719 L 8.101562 -25.894531 L 3.105469 -25.894531 Z M 3.105469 0 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.814483, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.132812 0.519531 C 18.273438 0.519531 22.046875 -2.40625 22.046875 -7.289062 C 22.046875 -11.394531 19.347656 -13.835938 12.910156 -15.351562 C 8.953125 -16.277344 7.582031 -17.273438 7.582031 -18.867188 C 7.582031 -20.566406 9.101562 -21.601562 11.578125 -21.601562 C 14.277344 -21.601562 15.90625 -20.199219 15.90625 -17.867188 L 21.566406 -17.867188 C 21.566406 -23.082031 17.644531 -26.410156 11.503906 -26.410156 C 5.546875 -26.410156 1.847656 -23.488281 1.847656 -18.753906 C 1.847656 -14.539062 4.699219 -12.023438 10.765625 -10.726562 C 14.425781 -9.949219 16.089844 -8.878906 16.089844 -7.066406 C 16.089844 -5.328125 14.539062 -4.328125 12.097656 -4.328125 C 9.246094 -4.328125 7.398438 -5.769531 7.398438 -8.25 L 1.628906 -8.25 C 1.628906 -2.886719 5.621094 0.519531 12.132812 0.519531 Z M 12.132812 0.519531 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.182055, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.320312 0 L 15.203125 0 L 15.203125 -20.382812 L 23.414062 -20.382812 L 23.414062 -25.894531 L 1.109375 -25.894531 L 1.109375 -20.382812 L 9.320312 -20.382812 Z M 9.320312 0 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.363395, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.105469 0 L 8.988281 0 L 8.988281 -25.894531 L 3.105469 -25.894531 Z M 3.105469 0 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.116397, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.320312 0 L 15.203125 0 L 15.203125 -20.382812 L 23.414062 -20.382812 L 23.414062 -25.894531 L 1.109375 -25.894531 L 1.109375 -20.382812 L 9.320312 -20.382812 Z M 9.320312 0 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.297738, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.6875 0.519531 C 20.417969 0.519531 24.527344 -3.699219 24.527344 -10.652344 L 24.527344 -25.894531 L 18.644531 -25.894531 L 18.644531 -11.058594 C 18.644531 -7.101562 16.980469 -5.066406 13.6875 -5.066406 C 10.394531 -5.066406 8.730469 -7.101562 8.730469 -11.058594 L 8.730469 -25.894531 L 2.847656 -25.894531 L 2.847656 -10.652344 C 2.847656 -3.699219 6.953125 0.519531 13.6875 0.519531 Z M 13.6875 0.519531 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.327246, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.320312 0 L 15.203125 0 L 15.203125 -20.382812 L 23.414062 -20.382812 L 23.414062 -25.894531 L 1.109375 -25.894531 L 1.109375 -20.382812 L 9.320312 -20.382812 Z M 9.320312 0 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.508574, 102.335806)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.105469 0 L 20.53125 0 L 20.53125 -4.992188 L 8.953125 -4.992188 L 8.953125 -10.652344 L 19.125 -10.652344 L 19.125 -15.574219 L 8.953125 -15.574219 L 8.953125 -20.9375 L 20.125 -20.9375 L 20.125 -25.894531 L 3.105469 -25.894531 Z M 3.105469 0 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7305823555)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 2.347656 80.152344 L 166.90625 80.152344 L 166.90625 100.144531 L 2.347656 100.144531 Z M 2.347656 80.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlackAndWhite);
export default __webpack_public_path__ + "static/media/logo-black-and-white.fbc218df3594a9ee6fd9519f52ffdd54.svg";
export { ForwardRef as ReactComponent };